import { Plus, Trash2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { rp, num, unitsOf, factorOf } from "@/lib/api";

export const blankLine = () => ({ item_id: "", qty: "", unit: "", unit_price: "" });

export const LineEditor = ({ lines, setLines, priced, stock, testid = "line" }) => {
  const { activeItems, itemById } = useAuth();
  const set = (i, patch) => setLines(lines.map((l, j) => (j === i ? { ...l, ...patch } : l)));
  const onItem = (i, id) => {
    const it = itemById[id];
    set(i, { item_id: id, unit: priced ? it?.purchase_unit || it?.base_unit : it?.transfer_unit || it?.base_unit, unit_price: priced && it ? "" : "" });
  };
  return (
    <div className="space-y-2">
      {lines.map((l, i) => {
        const it = itemById[l.item_id];
        const base = Number(l.qty || 0) * factorOf(it, l.unit);
        const st = stock?.[l.item_id];
        const total = Number(l.qty || 0) * Number(l.unit_price || 0);
        return (
          <div key={i} className="grid grid-cols-12 gap-2 items-start bg-slate-50 border border-slate-200 rounded-md p-2" data-testid={`${testid}-${i}`}>
            <div className="col-span-12 md:col-span-5">
              <select className="inp" value={l.item_id} onChange={(e) => onItem(i, e.target.value)} data-testid={`${testid}-${i}-item`}>
                <option value="">Pilih barang…</option>
                {activeItems.map((x) => <option key={x.id} value={x.id}>{`${x.name} (${x.sku})`}</option>)}
              </select>
              {it && (
                <div className="text-[11px] text-slate-500 mt-1">
                  = <span className="num">{num(base)}</span> {it.base_unit}
                  {st !== undefined && <> · tersedia <span className={`num ${st.available < base ? "text-rose-600 font-semibold" : "text-emerald-700"}`}>{num(st.available)}</span> {it.base_unit} · est. nilai {rp(base * st.unit_cost)}</>}
                </div>
              )}
            </div>
            <input className="inp col-span-4 md:col-span-2 num" type="number" step="any" min="0" placeholder="Qty" value={l.qty} onChange={(e) => set(i, { qty: e.target.value })} data-testid={`${testid}-${i}-qty`} />
            <select className="inp col-span-4 md:col-span-2" value={l.unit} onChange={(e) => set(i, { unit: e.target.value })} data-testid={`${testid}-${i}-unit`}>
              {unitsOf(it).map((u) => <option key={u} value={u}>{u}</option>)}
            </select>
            {priced && <input className="inp col-span-3 md:col-span-2 num" type="number" step="any" min="0" placeholder="Harga/unit" value={l.unit_price} onChange={(e) => set(i, { unit_price: e.target.value })} data-testid={`${testid}-${i}-price`} />}
            <button type="button" onClick={() => setLines(lines.filter((_, j) => j !== i))} className={`${priced ? "col-span-1" : "col-span-4 md:col-span-3 justify-self-end"} h-9 px-2 text-slate-400 hover:text-rose-600`} data-testid={`${testid}-${i}-remove`}><Trash2 size={16} /></button>
            {priced && <div className="col-span-12 text-right text-xs text-slate-600">Subtotal: <span className="num font-semibold text-slate-900">{rp(total)}</span></div>}
          </div>
        );
      })}
      <button type="button" onClick={() => setLines([...lines, blankLine()])} className="flex items-center gap-1.5 text-sm font-semibold text-emerald-700 hover:text-emerald-800" data-testid={`${testid}-add`}><Plus size={16} /> Tambah barang</button>
    </div>
  );
};

export const toPayload = (lines, priced) => lines.filter((l) => l.item_id && Number(l.qty) > 0).map((l) => ({ item_id: l.item_id, qty: Number(l.qty), unit: l.unit, ...(priced ? { unit_price: Number(l.unit_price || 0) } : {}) }));
